export default __webpack_public_path__ + "static/media/walmart_logo.03ae073a.png";